module.exports = __webpack_public_path__ + "img/no-image.b36566fe.jpg";